import { reactive } from "vue"

interface BannerDataHappy {
    banner_image_id: number
    language_id: number
    title: string
    image: string
    status: number
    text_web: string
    text_title_web: string
    text_footer_web: string
}

const state = reactive({
    banner: [] as BannerDataHappy[]
})

function setBannerData(data: BannerDataHappy[]) {
    state.banner = data
}

function getBannerData() {
    return state.banner
}

export type { BannerDataHappy as BannerDataHappyType }
export default {
    state,
    setBannerData,
    getBannerData
}
